import { ChangeDetectorRef, Component, effect, Inject, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadModule } from '@sbd-doug-frontend/shared/lib/ui/file-upload/file-upload.module';
import { FileUploadConfig } from '@sbd-doug-frontend/shared/lib/ui/file-upload/file-upload.component';
import { FileUploadService } from '@sbd-doug-frontend/shared/lib/ui/file-upload/file-upload.service';
import { CathyService } from '@sbd-account-portal/app/services/cathy.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sbd-doug-frontend-file-uploader-modal',
  standalone: true,
  imports: [CommonModule, FileUploadModule],
  templateUrl: './file-uploader-modal.component.html',
})
export class FileUploaderModalComponent implements OnInit {
  _changeDetector = inject(ChangeDetectorRef);
  uploadConfig: FileUploadConfig = {};
  contextId: string = '';
  context: string = '';
  isUploading: boolean = false;
  queuedFiles: File[] = [];
  uploadUrl: string = '';
  httpParamsName: string = '';
  title: string = 'Attach File(s)';
  private _fileUploadService = inject(FileUploadService);
  private _cathyService = inject(CathyService);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<FileUploaderModalComponent>,
  ) {
    effect(() => {
      this.isUploading = this._fileUploadService.isUploading();
    });
  }

  ngOnInit() {
    this.uploadConfig = this.data.uploadConfig;
    if (this.data?.context) {
      switch (this.data.context) {
        case 'cipquotereq':
          this.contextId = this.data.id;
          // this.uploadUrl = `${environment.apiBaseUrl}/v4/quote/request/${this.contextId}/upload-file`;
          this.httpParamsName = 'quote_request_files';
          this.title = 'Attach Quote Request File(s)';
          break;

        case 'cipxtask':
          this.httpParamsName = 'task_files';
          this.title = 'Attach Task File(s)';
          break;

        default:
          break;
      }
    }
  }

  onFileUploadChanged(files: File[]) {
    this.queuedFiles = files;
    if (this.data.context === 'cipxtask') {
      this.dialogRef.close({
        data: { queuedFiles: this.queuedFiles },
      });
    } else {
      if (this.queuedFiles) {
        this._fileUploadService.uploadFiles(this.uploadUrl,
          null,
          this.httpParamsName,
          this.queuedFiles,
        ).subscribe(ev => {
          if (!this._fileUploadService.isUploading()) {
            // console.log('uploadEv', ev);
            if (ev == 100) {
              let uploadResponse: any = {};
              // uploadResponse = <StandardResponse>this._fileUploadService.uploadResponse();
              // if (uploadResponse.success) {
              //   this.dialogRef.close();
              //   this._cathyService.success(uploadResponse.message);
              //   const files = uploadResponse.data?.quote_request?.files;
              //   this._openQuoteRequestsWidgetService.getOpenQuoteRequests().subscribe((r) => {
              //     const c = r.find(t => +t.quote_request_id === +this.contextId);
              //     this._openQuoteRequestsWidgetService.selectedOpenQR.set(c);
              //   });
              // }
              // if (uploadResponse.success) {
              // }
            }
          }
        });
      }
    }
  }

}
